import { Col, Row } from "react-bootstrap"
import { FaClipboardList, FaUsers } from "react-icons/fa"

const announceIcon = <svg xmlns="http://www.w3.org/2000/svg" width="44.009" height="33.974" viewBox="0 0 44.009 33.974"><path d="M-7679.79,10592.5a38.021,38.021,0,0,1-2.94-3.108,19.349,19.349,0,0,0-8.928-5.58,20.544,20.544,0,0,0-4.35-.75V10569a19.357,19.357,0,0,0,11.237-4.409c1.67-1.2,3.382-3.649,4.93-5a3.094,3.094,0,0,1,3.171-.185,3.092,3.092,0,0,1,1.661,2.706v27.84a3.1,3.1,0,0,1-.927,2.188,3.1,3.1,0,0,1-2.2.889,2.794,2.794,0,0,1-1.649-.529Zm-23.21-2.5v-5.288a7.3,7.3,0,0,0,2,.291h4v5a2.907,2.907,0,0,1-.862,2.129,2.9,2.9,0,0,1-2.138.839,2.906,2.906,0,0,1-2.138-.84A2.91,2.91,0,0,1-7703,10590Zm35.29-2.289-3-3a1,1,0,0,1,0-1.412,1,1,0,0,1,1.409,0l3,3a1,1,0,0,1,.207,1.1,1.006,1.006,0,0,1-.934.612.96.96,0,0,1-.683-.308Zm-38.2-8.809c-.17-.611-.059-4.2-.091-4.9a5,5,0,0,1,5-5h3v14h-3.041a5.045,5.045,0,0,1-4.878-4.1Zm36.911-1.9a1,1,0,0,1-1-1,1,1,0,0,1,1-1h6a1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm-1.7-9.7,3-3a.991.991,0,0,1,.7-.294.994.994,0,0,1,.7.293.991.991,0,0,1,.295.705.994.994,0,0,1-.294.705l-3,3a1.039,1.039,0,0,1-.709.29h-.033a1,1,0,0,1-.895-.629,1,1,0,0,1,.217-1.072Z" transform="translate(7706.008 -10559.057)" fill="currentColor" /></svg>
const trustIcon = <svg xmlns="http://www.w3.org/2000/svg" width="44.024" height="44.008" viewBox="0 0 44.024 44.008"><path d="M-7685.61,10435.9a1.177,1.177,0,0,1-.7-1.484l.833-2.2a1.179,1.179,0,0,1,1.519-.684,1.18,1.18,0,0,1,.657.613,1.171,1.171,0,0,1,.03.9l-.831,2.2a1.18,1.18,0,0,1-1.093.732,1.186,1.186,0,0,1-.416-.078Zm6.383-.335-2.8-1.367.225-.6a2.743,2.743,0,0,0-.426-2.686,2.748,2.748,0,0,0-2.537-.991,2.7,2.7,0,0,0-.227-1.275,2.749,2.749,0,0,0-1.551-1.445,2.74,2.74,0,0,0-2.12.091c0-.01,0-.021-.011-.028a2.732,2.732,0,0,0-1.836-1.533,2.729,2.729,0,0,0-2.338.491,2.749,2.749,0,0,0-2.108-1.213,2.762,2.762,0,0,0-2.247.93l-1.718-.687v-10.6l11.1-1.957c.231.176.451.333.666.482l-4.683,5.249a3.078,3.078,0,0,0-.816,2.107,3.124,3.124,0,0,0,1.856,2.861,3.131,3.131,0,0,0,3.368-.536l4.672-4.4a.783.783,0,0,1,.9-.129l8.7,4.463v.006a1.182,1.182,0,0,1,.521,1.544,1.179,1.179,0,0,1-1.519.594l-.016-.009-2.124-1.014a.779.779,0,0,0-.814.026.788.788,0,0,0-.354.736.784.784,0,0,0,.493.651l2.116,1.012.016.008a1.19,1.19,0,0,1,.661,1.064,1.27,1.27,0,0,1-.113.507,1.18,1.18,0,0,1-1.561.56h0l-2.281-1.092a.78.78,0,0,0-1,.385.786.786,0,0,0,.327,1.029l2.273,1.087s0,.008.011.008a1.181,1.181,0,0,1,.549,1.575,1.2,1.2,0,0,1-1.579.549l-2.15-1.032a.787.787,0,0,0-1.014.383.791.791,0,0,0,.333,1.033l2.161,1.036a1.168,1.168,0,0,1,.671,1.067,1.217,1.217,0,0,1-.112.512,1.156,1.156,0,0,1-.664.6,1.1,1.1,0,0,1-.389.067,1.2,1.2,0,0,1-.5-.089Zm-10.063-1.045a1.177,1.177,0,0,1-.7-1.487l1.388-3.67a1.164,1.164,0,0,1,.618-.658,1.184,1.184,0,0,1,.9-.028,1.175,1.175,0,0,1,.686,1.511l-1.388,3.673a1.178,1.178,0,0,1-1.092.735,1.176,1.176,0,0,1-.412-.1Zm-3.674-1.394a1.177,1.177,0,0,1-.7-1.477l1.385-3.67a1.18,1.18,0,0,1,1.522-.687,1.175,1.175,0,0,1,.657.613,1.182,1.182,0,0,1,.028.9l-1.384,3.669a1.178,1.178,0,0,1-1.088.724,1.156,1.156,0,0,1-.426,0Zm-3.7-1.346a1.178,1.178,0,0,1-.658-.616,1.162,1.162,0,0,1-.026-.9l1.11-2.943a1.169,1.169,0,0,1,.621-.653,1.165,1.165,0,0,1,.9-.021,1.162,1.162,0,0,1,.689,1.479l-1.121,2.965a1.184,1.184,0,0,1-1.107.759,1.158,1.158,0,0,1-.4-.049Zm-8.336-6a1,1,0,0,1-1-1v-9.793a1,1,0,0,1,1-1h3.5a1,1,0,0,1,1,1v9.793a1,1,0,0,1-1,1Zm38.524-1.574a1,1,0,0,1-1-1v-9.793a1,1,0,0,1,1-1h3.5a1,1,0,0,1,1,1v9.793a1,1,0,0,1-1,1Zm-5.987-2.829-8.68-4.46a2.364,2.364,0,0,0-2.7.384l-4.657,4.388a1.558,1.558,0,0,1-1.675.263,1.556,1.556,0,0,1-.917-1.428,1.507,1.507,0,0,1,.405-1.048l4.867-5.456c.492.278.89.479,1.139.595a1.618,1.618,0,0,0,.689.157,1.581,1.581,0,0,0,.681-.151,18.2,18.2,0,0,0,4.9-3.435l9.354,1.87v10.511l-1.873.386a2.745,2.745,0,0,0-1.531-2.553Zm-20.958-23.512.018-3.229a3.654,3.654,0,0,0,1.79-.967,3.806,3.806,0,0,0,.993-1.7l13.3.008a3.541,3.541,0,0,0,.959,1.691,3.622,3.622,0,0,0,1.81.963v3.233a16.487,16.487,0,0,1-9.46,15.325,16.545,16.545,0,0,1-9.409-15.291Zm4.162,4.555h0a.785.785,0,0,0,0,1.11l3.146,3.146a.787.787,0,0,0,1.111,0l7.862-7.861a.789.789,0,0,0,0-1.113.785.785,0,0,0-1.11,0l-7.309,7.307-2.59-2.59a.783.783,0,0,0-.555-.229.777.777,0,0,0-.556.31Z" transform="translate(7706 -10391.971)" fill="currentColor" /></svg>


export const DashboardCards = (data:any) => {
    const dashboardData = [
        {
            name: 'Users',
            bgClass: 'bg-link',
            cardIcon: <FaUsers size={49} />,
            dashboardCard: [
                {
                    id: '1',
                    title: 'Total',
                    value: data.cardData.user_info?data.cardData.user_info.total:0,
                },
                {
                    id: '2',
                    title: 'Free',
                    value: data.cardData.user_info?data.cardData.user_info.free:0,
                },
                {
                    id: '3',
                    title: 'Paid',
                    value: data.cardData.user_info?data.cardData.user_info.paid:0,
                },
            ]
        },
        {
            name: 'Legacy',
            bgClass: 'bg-primary',
            cardIcon: <FaClipboardList size={40} />,
            dashboardCard: [
                {
                    id: '1',
                    title: 'Total',
                    value: data.cardData.legacy_info?data.cardData.legacy_info.total:0,
                },
                {
                    id: '2',
                    title: 'Pending Approval',
                    value: data.cardData.legacy_info?data.cardData.legacy_info.pendingapproval:0,
                },
                {
                    id: '3',
                    title: 'Released',
                    value: data.cardData.legacy_info?data.cardData.legacy_info.released:0,
                },
            ]
        },
        {
            name: 'Public Proclamation',
            bgClass: 'bg-light',
            cardIcon: announceIcon,
            dashboardCard: [
                {
                    id: '1',
                    title: 'Total',
                    value: data.cardData.public_proclamation?data.cardData.public_proclamation.total:0,
                },
                {
                    id: '2',
                    title: 'Pending',
                    value: data.cardData.public_proclamation?data.cardData.public_proclamation.pending:0,
                },
                {
                    id: '3',
                    title: 'Published',
                    value: data.cardData.public_proclamation?data.cardData.public_proclamation.published:0,
                },
            ]
        },
        {
            name: 'Digital Trustees',
            bgClass: 'bg-link',
            cardIcon: trustIcon,
            dashboardCard: [
                {
                    id: '1',
                    title: 'Total',
                    value: data.cardData.digital_trustee?data.cardData.digital_trustee.total:0,
                },
                {
                    id: '2',
                    title: 'Not a User',
                    value: data.cardData.digital_trustee?data.cardData.digital_trustee.notuser:0,
                },
                {
                    id: '3',
                    title: 'Not Accepted',
                    value: data.cardData.digital_trustee?data.cardData.digital_trustee.notaccepted:0,
                },
            ]
        }
    ];
    return (
        <div className="dashBoardTop">
            {dashboardData.map((data: any) => {
                const { name, bgClass, cardIcon, dashboardCard } = data;
                return (
                    <div key={name}>
                        <h5 className="fw-bold pb-1 pt-2">{name}</h5>
                        <Row>
                            {dashboardCard.map((cardData: any) => {
                                const { id, title, value } = cardData;
                                return (
                                    <Col key={id} sm={6} lg={4} className="mb-3 mb-md-4">
                                        <div className="d-flex align-items-center w-100 h-100 border rounded-3 p-2">
                                            <div className={`align-items-center d-flex h-80 justify-content-center rounded-3 w-80 text-white me-3 ${bgClass}`}>
                                                {cardIcon}
                                            </div>
                                            <div className="ps-1">
                                                <h6 className="fs-18 mb-1">{title}</h6>
                                                <div className="display-1 fw-semibold">{value}</div>
                                            </div>
                                        </div>
                                    </Col>
                                )
                            })}

                        </Row>
                    </div>
                )
            })}

        </div>
    )
}
